<template>
    <section id="dashboard-ecommerce" class="ops-tracker-page" v-if="$can('read','pofu')">
      
      <div>
          <b-card>
            <div>
              <div class="ops-toolbar mb-2">
                <div class="d-flex align-items-center flex-wrap">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="ops-filter-toggle"
                    :class="{ 'ops-filter-toggle--active': showFilters || hasActiveFilters }"
                    :aria-expanded="showFilters ? 'true' : 'false'"
                    aria-controls="pofu-filter-panel"
                    v-b-tooltip.hover
                    title="Filters"
                    @click="showFilters = !showFilters"
                  >
                    <feather-icon icon="FilterIcon" size="16" />
                    <span
                      v-if="hasActiveFilters"
                      class="ops-filter-badge"
                      :title="`${activeFilterCount} active filter${activeFilterCount === 1 ? '' : 's'}`"
                    >{{ activeFilterCount }}</span>
                  </b-button>
                  <download-excel
                    v-if="!loading && hasResults && isReadyToDownload && $can('read','recruiter_filter')"
                    :data="exportData"
                    :name="filename"
                    class="ops-download-excel ml-50"
                  >
                    <b-button
                      size="sm"
                      variant="outline-success"
                      type="button"
                      class="ops-icon-btn"
                      v-b-tooltip.hover
                      title="Download Report"
                      aria-label="Download Report"
                    >
                      <feather-icon icon="DownloadIcon" size="16" />
                    </b-button>
                  </download-excel>
                  <div v-if="!loading && hasResults" class="ops-count ml-1">{{ totalRows }} candidates</div>
                </div>
                <div v-if="!loading && hasResults" class="d-flex flex-wrap align-items-center">
                    <b-input-group class="mb-1" style="min-width: 240px; max-width: 360px;">
                      <b-form-input
                        id="filterInput"
                        v-model="filter"
                        type="search"
                        placeholder="Search name, ID, status…"
                        :debounce="400"
                        trim
                      />
                      <b-input-group-append>
                        <b-button variant="outline-secondary" :disabled="!filter" @click="filter = ''">
                          Clear
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                </div>
              </div>

              <b-collapse id="pofu-filter-panel" v-model="showFilters">
                <div class="ops-filter-panel">
              <div class="d-flex flex-wrap align-items-center mb-1">
                <span class="ops-filter-label mb-0 mr-1">POFU status</span>
                <b-button variant="link" class="p-0" @click="clearSelected">Clear</b-button>
              </div>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="POFUOptions"
                name="fields-1"
                class="ops-status-checks mb-2"
              />
              <b-row>
                <b-col cols="12" md="6" lg v-if="$can('read','manager_filter')">
                  <b-form-group
                    label="Team Lead"
                    label-for="accountMgr"
                    label-class="ops-filter-label"
                  >
                    <v-select
                        v-model="mgrSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="asOptionsArray(accountMgr)"
                        :reduce="(option) => option.emp_id"
                        ref="accMgr"
                      />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg v-if="$can('read','recruiter_filter')">
                  <b-form-group
                    label="Recruiter"
                    label-for="recruiter"
                    label-class="ops-filter-label"
                  >
                    <v-select
                        v-model="recSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="asOptionsArray(recruiters)"
                        :reduce="(option) => option.emp_id"
                        ref="rec"
                      />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg>
                  <b-form-group
                    label="Location"
                    label-for="location"
                    label-class="ops-filter-label"
                  >
                    <v-select
                        v-model="locSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="asOptionsArray(location)"
                        :reduce="(option) => option.title"
                        ref="loc"
                      />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg>
                  <b-form-group
                    label="Client"
                    label-for="client"
                    label-class="ops-filter-label"
                  >
                    <v-select
                        v-model="clientSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="asOptionsArray(clients)"
                        :reduce="(option) => option.title"
                        ref="client"
                      />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg>
                  <b-form-group
                    label="Source"
                    label-for="source"
                    label-class="ops-filter-label"
                  >
                    <v-select
                        v-model="sourceSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="asOptionsArray(sources)"
                        :reduce="(option) => option.title"
                        ref="source"
                      />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col cols="12" md="4" class="mb-1">
                  <b-form-group class="mb-0">
                    <b-button variant="primary" size="sm" id="submit" type="button" @click="applyFilters">Apply</b-button>
                    <b-button variant="outline-secondary" size="sm" class="ml-1" type="button" @click="clearFilter">Clear Filter</b-button>
                  </b-form-group>
                </b-col>
              </b-row>
                </div>
              </b-collapse>
              
              <div v-if="loading" class="ops-loading">
                <b-spinner variant="primary" label="Loading POFU records" />
                <p class="ops-loading-text mt-1">Loading POFU records…</p>
              </div>
              <div v-if="error && !loading" class="ops-error mb-2">
                <h6 class="ops-error-title">{{ error }}</h6>
              </div>
              <div v-if="!loading && hasResults">
              <div class="ops-table-wrap">
              <b-table
                class="ops-table"
                hover
                responsive
                :items="compiledData"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="loading"
                @filtered="onFiltered"
              >
                <template #cell(pofu_id)="data" >
                      <div class="ops-id-link text-nowrap" @click="showPOFUTimeline(data.item)" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        v-b-modal.modal-pofu-timeline>
                          {{ data.item.pofu_id }} 
                      </div>
                  
                </template>
                <template #cell(candidate_name)="data">
                  <router-link
                                class="ops-cell-link"
                                :to="{
                                  name: 'apps-candidates-view',
                                  params: { id: data.item.cid, jobId: data.item.jid },
                                  query: { position_name: data.item.POSITION_NAME,
                                          client: data.item.CLIENT,
                                          attachments: data.item.attachments,
                                          recruiter: data.item.recruiter,
                                          locations: data.item.locations,
                                          sourcer: data.item.sourcer,
                                          am_name: data.item.account_mgr,
                                          position_type: data.item.type,
                                          vertical: data.item.vertical,
                                          category: data.item.category,
                                          payroll: data.item.payroll
                                  }
                                }"
                              >
                      <div class="ops-cell">
                          <div class="ops-name">{{ data.item.CANDIDATE_NAME }}</div>
                          <div class="ops-cell-id">{{ data.item.CAN_ID }}</div>
                      </div>
                  </router-link>
                </template>  
                <template #cell(position_name)="data" >
                <router-link class="ops-cell-link" :to="'/apps/view-job/' + data.item.jid">
                <div class="ops-cell">
                    {{ data.item.POSITION_NAME }} <br/>
                    {{ data.item.JOB_ID }} <br/>
                    {{ data.item.CLIENT }} <br/>
                    {{ data.item.poc }}
                    </div>
                </router-link>
                </template>
               
                <template #cell(recruiter)="data" >
                    <div class="text-nowrap" >
                      <span v-if="data.item.rec_name">{{ data.item.rec_name }} (R)<br/></span>
                      <span v-if="data.item.tl">{{ data.item.tl }} (TL)<br/></span>
                      <span v-if="data.item.p_mgr">{{ data.item.p_mgr }} (PM)<br/></span>
                      <span v-if="data.item.added_by">{{ data.item.added_by }} (A)<br/></span>
                    </div>
                </template>
                <template #cell(added_on)="data" >
                    <div class="text-nowrap" >
                      <span v-if="data.item.added_on">{{ data.item.added_on.split("T")[0] }} (A)<br/></span>
                      <span v-if="data.item.added_on">{{ data.item.updated_on.split("T")[0] }} (U)<br/></span>
                    </div>
                </template>
                <!-- <template #cell(recruiter)="data">
                    <div class="text-nowrap">
                      {{ data.item.scheduled_by }} (A)<br/>
                      {{ data.item.recruiter }} (R)<br/>
                      {{ data.item.sourcer }} (S)<br/>
                      {{ data.item.account_mgr }} (AM)<br/>
                      {{ data.item.team_lead }} (TL)<br/>
                    </div>
                </template> -->
                <template #cell(candidateStatus)="data">
                    <div class="text-nowrap">
                    {{ data.item.candidateStatus }} <br/>
                    {{ data.item.source }} 
                    </div>
                </template>
                <template #cell(latestOfferStage)="data">
                    <div class="text-nowrap">
                      <span v-if="data.item.CLIENT === 'KPMG RPO' && data.item.latestOfferStage">
                        <b-badge pill class="badge-info">
                          {{ data.item.latestOfferStage }}
                        </b-badge>
                      </span>
                      <span v-else class="text-muted">
                        N/A
                      </span>
                    </div>
                </template>
                <template #cell(offered_date)="data">
                    <div class="text-nowrap">
                      {{ formatDisplayDate(resolveOfferedDate(data.item)) }}
                    </div>
                </template>
                <template #cell(joining_date)="data">
                    <div class="text-nowrap">
                      {{ formatDisplayDate(resolveJoiningDate(data.item)) }}
                    </div>
                </template>
                <template #cell(status)="data">
                    <div class="text-nowrap">
                      <b-badge pill class="text-capitalize"
                        :class="resolvePOFUStatusVariant(data.item.status)">
                          <span v-if="data.item.status">{{ data.item.status }}</span>
                          <span v-else> NOT INITIATED</span>
                      </b-badge>
                    </div>
                </template>
                <template #cell(comment)="data" >
                    <div class="ops-comment-cell" :title="data.item.comment">
                    {{ data.item.comment }}
                    </div>
                </template>
                
                <template #cell(actions)="data" >
                    <div class="ops-action-stack" v-if="$can('create','pofu')">
                      <b-button
                        size="sm"
                        :variant="data.item.status ? 'success' : 'info'"
                        @click="sendCandidateItemToModal(data.item)"
                        v-b-modal.modal-pofu-update
                      >
                        {{ data.item.status ? 'Update' : 'Initiate' }}
                      </b-button>
                    </div>
                </template>
                
              </b-table>
              </div>
              <b-pagination
                v-if="totalRows > perPage"
                v-model="currentPage"
                size="sm"
                class="ops-pagination"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
              />
              </div>
              
              <div v-if="!loading && !hasResults" class="ops-empty">
                <h6 class="ops-empty-title">{{ reportStatus || 'No POFU records found' }}</h6>
                <p class="ops-empty-hint">Adjust filters, then click Apply.</p>
              </div>   
            </div>
          </b-card>  
        </div>
        <!--:title="candidate_id + ' - ' + candidate_name + ' - ' + position + ' - ' + client"-->
        <b-modal
          id="modal-pofu-update"
          ok-title="submit"
          cancel-variant="outline-secondary"
          @ok="updatePOFU"
        >
          <b-form > 
              
              <b-form-group label="Select POFU Status *" label-for="pofu-status">
                <v-select
                    v-model="pofuStatusSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="asOptionsArray(POFUStatusOptions)"
                    label="title"
                    :reduce="(option) => option.title"
                />
              </b-form-group>
              
              <!-- Additional fields for Offer Accepted candidates - only show for On-Track status -->
              <div v-if="currentStatus === 'Offer Accepted' && pofuStatusSelected === 'On-Track'" class="offer-accepted-fields">
                <h6 class="text-primary mb-3">
                  <i class="fas fa-info-circle mr-1"></i>
                  Candidate Status Update Required
                </h6>
                
                <b-form-group label="Offered Date *" label-for="offered-date">
                  <flat-pickr
                    v-model="offeredDate"
                    class="form-control"
                    :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
                    placeholder="Select Offered Date"
                  />
                </b-form-group>
                
                <b-form-group label="Joining Date *" label-for="joining-date">
                  <flat-pickr
                    v-model="joiningDate"
                    class="form-control"
                    :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
                    placeholder="Select Joining Date"
                  />
                </b-form-group>
                
                <b-form-group label="Offered CTC *" label-for="offered-ctc">
                  <b-form-input
                    id="offered-ctc"
                    v-model="offeredCTC"
                    type="number"
                    placeholder="Enter Offered CTC"
                    min="0"
                    step="0.01"
                  />
                </b-form-group>
              </div>
              
              
              <b-form-group
                label="Enter notes *"
                label-for="pofu-notes"
              >
                <b-form-textarea
                  id="textarea-default"
                  placeholder="Enter notes/comment (mandatory)"
                  v-model="pofu_notes"
                  rows="3"
                  :state="pofu_notes && pofu_notes.trim().length > 0"
                />
                <small v-if="!pofu_notes || !pofu_notes.trim().length" class="text-danger">
                  Notes are mandatory for POFU status updates
                </small>
              </b-form-group>
            </b-form>
        </b-modal>
        <b-modal
          id="modal-pofu-timeline"
          ok-only
          ok-title="OK"
          centered
          size="xl"
        >
          <b-table class="ops-table" responsive="sm" :items="pofuTimeline" :fields="timelineFields"> 
            <template #cell(pofu_id)="data" >
                <div class="text-nowrap">
                  {{ data.item.pofu_id }}
                </div>
            </template>
            <template #cell(added_by)="data" >
                <div class="text-nowrap">
                  {{ data.item.added_by }}
                </div>
            </template>
            <template #cell(status)="data" >
                <div class="text-nowrap">
                  <b-badge pill class="text-capitalize"
                        :class="resolvePOFUStatusVariant(data.item.status)">
                          {{ data.item.status }}
                  </b-badge>
                </div>
            </template>
            <template #cell(comment)="data" >
                <div class="text-wrap">
                  {{ data.item.comment }}
                </div>
            </template>
            <template #cell(added_on)="data" >
                <div class="text-nowrap">
                  {{ data.item.added_on }}
                </div>
            </template>
          </b-table>
        </b-modal>  
    </section>
  </template>
  
  <script>
  import { BRow, BCol, BCard, BCardBody, BButton, BForm, BFormGroup, BSpinner, BFormCheckbox, BFormCheckboxGroup, BTable, BBadge, BModal, VBModal, VBTooltip, BFormTextarea, BFormInput, BInputGroup, BInputGroupAppend, BPagination, BCollapse } from 'bootstrap-vue'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import vSelect from 'vue-select'
  import moment from 'moment'
  import UserService from '@/services/user-service'
  import clientService from '@/services/client-service'
  import pofuService from '@/services/pofu-service'
  import candidateService from '@/services/candidate-service'
  //import Ripple from 'vue-ripple-directive'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import adminConfigService from "@/services/admin-config-service";
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardBody,
      BButton,
      BForm, 
      BFormGroup,
      BSpinner,
      BFormCheckbox,
      BFormCheckboxGroup,
      BFormInput, BInputGroup, BInputGroupAppend,
      BPagination,
      BCollapse,
      // ExportExcelSheetVueJs,
      ToastificationContent,
      BFormTextarea,
      BTable,
      BBadge,
      vSelect, BModal, VBModal, flatPickr,
      
    },
    data() {
      return {
        startDate: '',
        endDate: '',
        //interview_date: '',
        tracker: '',
        compiledData: [],
        loading: true,
        downloadReport: '',
        recruiters: [],
        recSelected: '',
        accountMgr: [],
        mgrSelected: '',
        sourceSelected: '',
        clients: [],
        filter: null,
        sortDirection: 'asc',
        filterOn: [],
        clientSelected: '',
        location: [{ title: 'Pune' }, { title: 'Delhi'}],
        locSelected: '',
        filename: '',
        columns: [{ label: 'Manager', field: 'Manager'}, { label: 'Recruiter', field: 'Recruiter'}, { label: 'Client', field: 'Client'}, { label: 'Location', field: 'Location'}, { label: 'Total Candidates', field: 'TotalCandidates'}, 
          { label: 'Profile Shared', field: 'ProfileShared'}, { label: 'Review Reject', field: 'ReviewReject'}, { label: 'Initiated', field: 'Initiated'}, { label: 'Not Interested', field: 'NotInterested'}, { label: 'Not Relevant', field: 'NotRelevant'}, 
          { label: 'Not Answered', field: 'NotAnswered'}, { label: 'Not Reachable', field: 'NotReachable'}, { label: 'Wrong Number', field: 'WrongNumber'}, { label: 'Call Back', field: 'CallBack'}, { label: 'Screen Select', field: 'ScreenSelect'},
          { label: 'Screen Reject', field: 'ScreenReject'}, { label: 'Duplicate', field: 'Duplicate'}, { label: 'InProcess', field: 'InProcess'}, { label: 'On Hold', field: 'OnHold'}, { label: 'Shortlisted', field: 'Shortlisted'},
          { label: 'Rejected', field: 'Rejected'}, { label: 'Offered', field: 'Offered'}, { label: ' Not Offered', field: 'NotOffered'}, { label: 'Offer Drop', field: 'OfferDrop'}, { label: 'Joined', field: 'Joined'}],
        reportStatus: '',
        
        // options: [
        //   { text: 'Recruiter', value: 'recruiter' },
        //   { text: 'Team Lead', value: 'manager' },
        //   { text: 'Location', value: 'location' },
        //   { text: 'Client', value: 'client' },
        //   { text: 'Source', value: 'source' },
        // ],
        //interviewStatusOptions: [{ title: "Naukri" }, { title: "Monster" }],
        sources: [
          { title: "Naukri" },
          { title: "Monster" },
          { title: "ATS" },
          { title: "LinkedIn" },
          { title: "Indeed" },
          { title: "Shine" },
          { title: "TimesJobs" },
          { title: "IIMJobs" },
          { title: "Glassdoor" },
          { title: "FreshersWorld" },
          { title: "Other" },
          { title: "Train N Hire" },
          { title: "Internal" },
          { title: "Referenced" },
        ],
        sheetname: 'Status Wise Tracker',
        isReadyToDownload: false,
        sourceSelected: '',
        fields: [
          { key: 'pofu_id', label: 'ID', sortable: true, thStyle: { width: "8%" }	 },
          { key: 'candidate_name', label: 'Name', sortable: true, thStyle: { width: "12%" } },
          { key: 'position_name', label: 'Position', sortable: true, thStyle: { width: "12%" } },
          { key: 'recruiter', label: 'Recruiter', sortable: true, thStyle: { width: "8%" } },
          { key: 'added_on', label: 'Updated On', sortable: true, thStyle: { width: "8%" } },
          { key: 'candidateStatus', label: 'Candidate Status', sortable: true, thStyle: { width: "8%" } },
          { key: 'latestOfferStage', label: 'Latest Offer Stage', sortable: true, thStyle: { width: "10%" } },
          { key: 'offered_date', label: 'Offered Date', sortable: true, thStyle: { width: "8%" } },
          { key: 'joining_date', label: 'Joining', sortable: true, thStyle: { width: "8%" } },
          { key: 'status', label: 'POFU Status', sortable: true, thStyle: { width: "8%" } },
          { key: 'comment', label: 'POFU Comment', sortable: true, thStyle: { width: "8%" } },
          { key: "actions", label: 'Actions', thStyle: { width: "18%" } },
          
        ],
        timelineFields: [
        { key: 'pofu_id', label: 'ID', sortable: true },
          { key: 'added_by', label: 'ADDED BY', sortable: true },
          { key: 'status', label: 'POFU Status', sortable: true },
          { key: "comment", label: 'comment' },
          { key: "added_on", label: 'Added On' },
        ],
        POFUStatusOptions: [
          { title: "On-Track"},
          { title: "On Hold"},
          { title: "Potential Drop"},
          { title: "Drop"},
        ],
        selected: [null,"On-Track","Potential Drop","Drop"],
        POFUOptions: [
          { text: "Not Initiated", value: null},
          { text: "On-Track", value: "On-Track"},
          { text: "Potential Drop", value: "Potential Drop"},
          { text: "Drop", value: "Drop"},
        ],
        pofu_notes: '',
        pofuTimeline: [],
        error: '',
        sortBy: '',
        sortDesc: '',
        pofuItems: [],
        pofuStatusSelected: '',
        //interviewStatusSel: ''
        
        // Additional fields for Offer Accepted candidates
        offeredDate: '',
        joiningDate: '',
        offeredCTC: '',
        currentStatus: '',
        totalRows: 0,
        currentPage: 1,
        perPage: 25,
        showFilters: false,
        dateEnrichGen: 0,
      }
    },
    directives: {
        'b-modal': VBModal,
        'b-tooltip': VBTooltip,
        Ripple,
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => ({ text: f.label, value: f.key }))
      },
      hasResults() {
        return Array.isArray(this.compiledData) && this.compiledData.length > 0
      },
      exportData() {
        if (!this.hasResults) return []
        return this.compiledData.map(item => {
          const offered = this.formatDisplayDate(this.resolveOfferedDate(item))
          const joining = this.formatDisplayDate(this.resolveJoiningDate(item))
          return {
            ...item,
            offered_date: offered === '—' ? '' : offered,
            joining_date: joining === '—' ? '' : joining,
          }
        })
      },
      hasActiveFilters() {
        return this.activeFilterCount > 0
      },
      activeFilterCount() {
        let count = 0
        if (this.selected.length > 0 && this.selected.length < this.POFUOptions.length) count += 1
        if (this.mgrSelected) count += 1
        if (this.recSelected) count += 1
        if (this.locSelected) count += 1
        if (this.clientSelected) count += 1
        if (this.sourceSelected) count += 1
        return count
      },
    },
    watch: {
      mgrSelected: function(newMgr) {
          //let cgst = 0.0
          this.filterRecruiters();
          //return this.cgst
      },
      
      // Watch for route query changes
      '$route.query.filter': function(newFilter) {
        if (newFilter) {
          this.filter = newFilter
          console.log('Filter updated from route query:', newFilter)
        }
      },

    },
    created() {
      this.startDate = moment().locale("en").add(-7, 'days').format("YYYY-MM-DD")
      this.endDate = moment().locale("en").add(7, 'days').format("YYYY-MM-DD")
      
      // Get filter from route query if available
      if (this.$route.query.filter) {
        this.filter = this.$route.query.filter
        console.log('Filter from route query:', this.filter)
      }
  
      // UserService.getAllUsersDdActiveInactive().then( res => {
      //   if(res.status === "OK") {
      //     //console.log("in if")
      //     if(user)
      //     this.recruiters = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager" || item.role === "talent-advisor");
      //     this.accountMgr = res.data.filter(item => item.role === "account-manager");
      //   }
        
      // })
      this.role = JSON.parse(localStorage.getItem('userData')).roles[0]
      const emp_id = JSON.parse(localStorage.getItem('userData')).emp_id
      const mgr_id = JSON.parse(localStorage.getItem('userData')).mgr_id
      const title = JSON.parse(localStorage.getItem('userData')).first_name + ' ' + JSON.parse(localStorage.getItem('userData')).last_name
      this.recruiters = [{
          "id": 1,
          "title": "All",
          "emp_id": "All"
      }]
      // UserService.getAllUsersDd().then( res => {
      // if(res.status === "OK") {
      //   console.log("in if")
        //   const allUsers = JSON.parse(localStorage.getItem('allusers'))
        //   console.log('allUsers', allUsers)
        //  if (this.role === 'ACCOUNT-MANAGER') {
        //   const self = [{
        //     "id": 111111,
        //     "title": title,
        //     "emp_id": emp_id,
        //     "mgr_id": mgr_id,
        //     "role": this.role
        //   }]
        //   const recs = allUsers.filter(item => (item.role.toLowerCase() === "TALENT-ADVISOR-SOURCER".toLowerCase() || item.role.toLowerCase() === "TALENT-ADVISOR".toLowerCase())  && item.manager === emp_id);  
        //   console.log('recs', recs)
        //   this.recruiters = [...this.recruiters, ...self, ...recs]
        //   console.log(this.recruiters)
        //   for (let i = 0; i < this.recruiters.length; i++) {
        //     const id = "'" + this.recruiters[i].emp_id + "'|"
        //     console.log(id)
        //     this.all_ids = this.all_ids + id
        //   }
        //   console.log(this.all_ids)
        //   this.accountMgr = self
        // } else if (this.role === 'TALENT-ADVISOR' || this.role === 'TALENT-ADVISOR-SOURCER') {
        //   const recs = []
        //   this.recruiters = [...this.recruiters, ...recs]
        //   const mgr = allUsers.filter(item => item.role.toLowerCase() === "ACCOUNT-MANAGER".toLowerCase() && item.emp_id === mgr_id );
        //   this.accountMgr = [{
        //     "id": 111111,
        //     "title": mgr[0].title,
        //     "emp_id": mgr_id,
        //     "mgr_id": mgr[0].manager,
        //     "role":  mgr[0].role
        //   }]
        //   //this.accountMgr = 
        // } else {
        //   const recs = allUsers.filter(item => item.role.toLowerCase() === "TALENT-ADVISOR-SOURCER".toLowerCase() || item.role.toLowerCase() === "ACCOUNT-MANAGER".toLowerCase() || item.role.toLowerCase() === "TALENT-ADVISOR".toLowerCase());
        //   this.recruiters = [...this.recruiters, ...recs]
        //   this.accountMgr = allUsers.filter(item => item.role.toLowerCase() === "ACCOUNT-MANAGER".toLowerCase())
        // }
        UserService.getAllTeamMembersList(emp_id).then(res =>{
          console.log('recruiters ',res.data)
          this.recruiters = this.asOptionsArray(res && res.data)
          for (let i = 0; i < this.recruiters.length; i++) {
                const id = "'" + this.recruiters[i].emp_id + "'|"
                // console.log(id)
                this.all_ids = this.all_ids + id
          }
          this.getReport()
        })
        UserService.getAllManagersList().then(res =>{
          console.log('managers ',res.data)
          this.accountMgr = this.asOptionsArray(res && res.data)
          // for (let i = 0; i < this.recruiters.length; i++) {
          //       const id = "'" + this.recruiters[i].emp_id + "'|"
          //       // console.log(id)
          //       this.all_ids = this.all_ids + id
          // }
        })

        console.log(this.recruiters)
      clientService.getClients().then(res => {
        this.clients = this.asOptionsArray(res && res.data)
        console.log(this.clients)
      })
      
      
    },
    methods: {
      asOptionsArray(value) {
        return Array.isArray(value) ? value : []
      },
      applyFilters() {
        this.getReport()
        this.showFilters = false
      },
      getReport() {
        if(!this.$can('read','pofu')) {
          return
        }
        this.error = ''
        this.compiledData = []
        this.tracker = []
        const emp_id  = JSON.parse(localStorage.getItem('userData')).emp_id
        const userRole = JSON.parse(localStorage.getItem('userData')).roles[0]

        // if (this.startDate === '' || this.endDate === '') {
        //   this.reportStatus = 'Please Select Dates'
        // } else {
          this.loading = true
          //console.log(this.startDate, this.endDate, moment().locale("en").format("YYYY-MM-DD"))
          //console.log('DATE CHECK', new Date(this.startDate) < new Date(moment().locale("en").format("YYYY-MM-DD")))
          // this.rec = this.selected.includes('recruiter')
          // this.mgr = this.selected.includes('manager')
          // this.loc = this.selected.includes('location')
          // this.client = this.selected.includes('client')
          console.log(this.selected)
          let ids = ""
          console.log(this.recruiterSelected, this.statusSelected)
          // if(userRole === 'ACCOUNT-MANAGER' ) {
          //   this.all_ids = this.all_ids.substring(0, this.all_ids.length-1);
          //   ids = this.recruiterSelected ? (this.recruiterSelected === 'All' ? this.all_ids : this.recruiterSelected) : emp_id
          //   console.log(ids)
          // } else if(userRole === 'TALENT-ADVISOR' || userRole === 'TALENT-ADVISOR-SOURCER') {
          //   ids = emp_id
          //   console.log(ids)
          // } else {
          //   // for admin, master, hr,mis, no condition 
          //   ids = emp_id
          //   console.log(ids)
          // } 

          if(this.$can('read','admin') || this.$can('read','hr') || this.$can('read','master')) {
            // for admin, master, hr,mis, no condition 
            ids = emp_id
            console.log('other ids',ids)
          } else if(this.$can('read','account_manager') ) {
            this.all_ids = this.all_ids.substring(0, this.all_ids.length-1);
            ids = this.recruiterSelected ? (this.recruiterSelected === 'All' ? this.all_ids : this.recruiterSelected) : emp_id
            console.log('account_manager',ids)
          } else if(this.$can('read','talent_acquisition')) {
            ids = emp_id
            console.log('talent advisor',ids)
          }
          
          //console.log(this.rec, this.mgr, this.loc, this.client)
          this.recSelected = this.recSelected == null || this.recSelected == undefined ? '' : this.recSelected
          this.mgrSelected = this.mgrSelected == null || this.mgrSelected == undefined ? '' : this.mgrSelected
          this.locSelected = this.locSelected == null || this.locSelected == undefined ? '' : this.locSelected
          this.clientSelected = this.clientSelected == null || this.clientSelected == undefined ? '' : this.clientSelected
          this.sourceSelected = this.sourceSelected == null || this.sourceSelected == undefined ? '' : this.sourceSelected
          if (new Date(this.startDate) <= new Date(moment().locale("en").format("YYYY-MM-DD")) && (new Date(this.startDate) <= new Date(this.endDate))) {
            pofuService.getAll( this.recSelected, this.mgrSelected, this.clientSelected, this.locSelected , this.sourceSelected, emp_id, userRole, ids).then(res => {
                if (res.status === "OK") {
                  //this.reportStatus = ''

                  // Process data to add latest offer stage for KPMG RPO clients
                  // and normalize offered/joining dates from list + nested extra_details/offer letter
                  let processedData = res.data.map(item => this.normalizePofuRow(item));

                  if (this.selected.length === 4 ) {
                  this.compiledData = processedData
                  this.totalRows = processedData.length
                  } else if(this.selected.length > 0) {

                    for (let i = 0; i < this.selected.length; i++) {
                      const data = processedData.filter( item => item.status === this.selected[i])
                      this.compiledData = [...this.compiledData, ...data]
                    }
                  } else {
                      this.compiledData = processedData
                  }
                this.totalRows = this.compiledData.length
                this.currentPage = 1
                console.log(res)
                this.filename = 'POFU Tracker.xls'
                this.loading = false
                this.isReadyToDownload = false
                this.enrichOfferedJoiningDates(this.compiledData)
  
                if(this.compiledData.length === 0) {
                  this.error = 'No Data found'
                }
              } else if ((res.status === 401 ) || (res.status === 403 )) {
                window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                this.reportStatus = 'Session Expired... Redirecting to Login Page'
                localStorage.clear();
                this.$router.push({ name: "auth-login" });
              } else if ((res.status === 400 ) ) {
                this.reportStatus = 'No Data Found for Selected Dates'
                this.loading = false
                this.compiledData = null
              }
              else if ((res.status === 500 ) ) {
                this.reportStatus = 'ERROR: ' + res.data.message + 'Kindly contact IT admin.'
                this.loading = false
                this.compiledData = null
              }
            })
          } else if (new Date(this.startDate) > new Date(this.endDate)) {
            this.loading = false
            this.reportStatus = 'Start Date cannot be greater than End Date!!!'
          }
            else {
            this.loading = false
            this.reportStatus = 'Start Date cannot be greater than today!!!'
          }
        //}  
      },
      updatePOFU() {
        this.error = ''
        
        // Validate mandatory fields
        if (!this.pofu_notes || !this.pofu_notes.trim().length) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notes are mandatory for POFU status updates",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        
        // Validate additional fields for Offer Accepted candidates - only for On-Track status
        if (this.currentStatus === 'Offer Accepted' && this.pofuStatusSelected === 'On-Track') {
          if (!this.offeredDate) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Offered Date is mandatory for Offer Accepted candidates with On-Track status",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            return;
          }
          if (!this.joiningDate) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Joining Date is mandatory for Offer Accepted candidates with On-Track status",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            return;
          }
          if (!this.offeredCTC) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Offered CTC is mandatory for Offer Accepted candidates with On-Track status",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            return;
          }
        }

        const userData = JSON.parse(localStorage.getItem("userData"));
        console.log('pofuStatusSelected', this.pofuStatusSelected)
        
        // Create POFU data
        const pofuData = {
          candidate_id: this.cid,
          job_id: this.jobid,
          added_by: userData.emp_id,
          status: this.pofuStatusSelected,
          parent_id: this.pofu_id,
          comment: this.pofu_notes,
          recruiter: this.recruiter,
          tl: this.tl,
          p_mgr: this.p_mgr,
          position_name: this.position,
          client: this.client,
          cname: this.cname
        }
        
        console.log('POFU data:', pofuData)
        
        // First create POFU record
        pofuService.create(pofuData).then(res => {
          if (res.status === "OK") {
            console.log('POFU created:', res)
            
            // If candidate status is "Offer Accepted" and POFU status is "On-Track", update candidate status to "Offered"
            if (this.currentStatus === 'Offer Accepted' && this.pofuStatusSelected === 'On-Track') {
              this.updateCandidateStatusToOffered();
            }
            else if (this.currentStatus === 'Offer Accepted' && this.pofuStatusSelected === 'On-Hold') {
              this.updateCandidateStatusToOnHold();
            }
            else if (this.currentStatus === 'Offer Accepted' && (this.pofuStatusSelected === 'Drop' || this.pofuStatusSelected === 'Potential Drop')) {
              // Show success message and refresh report

              this.updateCandidateStatusToDrop();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU " + this.pofuStatusSelected + " created successfully!",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.getReport();
            }
            
          } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            this.error = 'Session Expired... Redirecting to Login Page'
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          } else if ((res.status === 400 ) ) {
            this.error = 'Some Error Occurred, Please Try after sometime. If Same Issue occurs multiple times, Kindly contact IT admin.'
            this.loading = false
            this.compiledData = null
          }
          else if ((res.status === 500 ) ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "POFU " + this.pofuStatusSelected + " Failed!!!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            this.error = 'ERROR: ' + res.data.message + 'Kindly contact IT admin.'
            this.loading = false
            this.compiledData = null
          }
        })
      },
      
      updateCandidateStatusToOffered() {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const username = `${userData.first_name} ${userData.last_name}`
        const candidateUpdateData = {
          candidateStatus: 'Offered',
          offered_date: this.offeredDate,
          joining_date: this.joiningDate,
          offered_ctc: this.offeredCTC,
          updatedBy: user
        };

        const timelineData = {
                title: `Candidate - ${this.cid} Status Changes to ${candidateUpdateData.candidateStatus}`,
                description: `CS-Changed`, /// CS-Changed means candidate status changed
                type: "success",
                createdBy: username,
                jobId: this.jobid,
                action: 'pofu',
                candidate_id: this.cid,
                candidateStatus: candidateUpdateData.candidateStatus,
              }

        candidateUpdateData.jt = timelineData  
        
        console.log('Updating candidate status to Offered:', candidateUpdateData);
        
        candidateService.updateCandidateStatus(this.cid, this.jobid, candidateUpdateData).then(
          response => {
            if (response.status === 'OK') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created and candidate status updated to Offered successfully!",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.getReport();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created but candidate status update failed",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
              this.getReport();
            }
          },
          error => {
            console.error('Error updating candidate status:', error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "POFU created but candidate status update failed",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            this.getReport();
          }
        );
      },
      updateCandidateStatusToDrop() {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const username = `${userData.first_name} ${userData.last_name}`
        const candidateUpdateData = {
          candidateStatus: 'OfferDrop',
          drop_reason: this.pofu_notes,
          updatedBy: user
        };

        const timelineData = {
                title: `Candidate - ${this.cid} Status Changes to ${candidateUpdateData.candidateStatus}`,
                description: `CS-Changed`, /// CS-Changed means candidate status changed
                type: "success",
                createdBy: username,
                jobId: this.jobid,
                action: 'pofu',
                candidate_id: this.cid,
                candidateStatus: candidateUpdateData.candidateStatus,
              }

        candidateUpdateData.jt = timelineData  
        
        console.log('Updating candidate status to Offered:', candidateUpdateData);
        
        candidateService.updateCandidateStatus(this.cid, this.jobid, candidateUpdateData).then(
          response => {
            if (response.status === 'OK') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created and candidate status updated to OfferDrop successfully!",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.getReport();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created but candidate status update failed",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
              this.getReport();
            }
          },
          error => {
            console.error('Error updating candidate status:', error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "POFU created but candidate status update failed",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            this.getReport();
          }
        );
      },
      updateCandidateStatusToOnHold() {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const username = `${userData.first_name} ${userData.last_name}`
        const candidateUpdateData = {
          candidateStatus: 'On Hold',
          drop_reason: this.pofu_notes,
          updatedBy: user
        };

        const timelineData = {
                title: `Candidate - ${this.cid} Status Changes to ${candidateUpdateData.candidateStatus}`,
                description: `CS-Changed`, /// CS-Changed means candidate status changed
                type: "success",
                createdBy: username,
                jobId: this.jobid,
                action: 'pofu',
                candidate_id: this.cid,
                candidateStatus: candidateUpdateData.candidateStatus,
              }

        candidateUpdateData.jt = timelineData  
        
        console.log('Updating candidate status to On Hold:', candidateUpdateData);
        
        candidateService.updateCandidateStatus(this.cid, this.jobid, candidateUpdateData).then(
          response => {
            if (response.status === 'OK') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created and candidate status updated to On Hold successfully!",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.getReport();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "POFU created but candidate status update failed",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
              this.getReport();
            }
          },
          error => {
            console.error('Error updating candidate status:', error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "POFU created but candidate status update failed",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            this.getReport();
          }
        );
      },
      
      showPOFUTimeline(data) {
        this.error = ''
        console.log('cid-jid', data.cid, data.jid, data.parent_id)
        const pid = data.parent_id ? data.parent_id : data.pofu_id
        pofuService.getCandidateJobPOFUs(data.cid, data.jid, pid).then(res => {
            if (res.status === "OK") {
              console.log(res)
              this.pofuTimeline = res.data

              
            } else if ((res.status === 401 ) || (res.status === 403 )) {
              window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
              this.error = 'Session Expired... Redirecting to Login Page'
              localStorage.clear();
              this.$router.push({ name: "auth-login" });
            } else if ((res.status === 400 ) ) {
              this.error = 'Some Error Occurred, Please Try after sometime. If Same Issue occurs multiple times, Kindly contact IT admin.'
              this.loading = false
              this.compiledData = null
            }
            else if ((res.status === 500 ) ) {
              this.$toast({
                            component: ToastificationContent,
                            props: {
                            title: "Interview details get Failed!!!",
                            icon: "EditIcon",
                            variant: "danger",
                            },
                        });
              this.error = 'ERROR: ' + res.data.message + 'Kindly contact IT admin.'
              this.loading = false
              this.compiledData = null
            }
          })
      },
      sendCandidateItemToModal(data) {

        
        this.pofuStatusSelected = data.status
        console.log('status', this.pofuStatusSelected)
        this.cid = data.cid
        this.jobid = data.jid
        this.cname = data.CAN_ID + ' ' + data.CANDIDATE_NAME
        this.position = data.JOB_ID + ' ' + data.POSITION_NAME
        this.client = data.CLIENT
        this.currentStatus = data.candidateStatus
        this.recruiter = JSON.parse(localStorage.getItem("allusers")).filter(item => item.emp_id === data.recruiter)[0]
        this.tl = JSON.parse(localStorage.getItem("allusers")).filter(item => item.emp_id === data.mgr_id)[0]
        this.p_mgr = JSON.parse(localStorage.getItem("allusers")).filter(item => item.emp_id === data.p_mgr_id)[0]
        //this.interview_date = data.date_time
        //this.interview_status = data.status
        //this.pofu_notes = data.comment
        this.pofu_id = data.parent_id ? data.parent_id : data.pofu_id
        // this.revenue = data.revenue
        // this.revenue_confirmed = data.revenue_confirmed
        
        // Reset additional fields for Offer Accepted candidates
        this.offeredDate = ''
        this.joiningDate = ''
        this.offeredCTC = ''
        },
      numDaysBetween(d1, d2) {
          var diff = Math.abs(d1.getTime() - d2.getTime());
          return diff / (1000 * 60 * 60 * 24);
      } ,
      resolvePOFUStatusVariant(status) {
      //console.log("called")
      //const resolveCandidateStatusVariant = status => {
        
        if (status === 'On-Track') return 'badge-success'
        if (status === 'Potential Drop') return 'badge-warning'
        if (status === 'Drop') return 'badge-danger'
        return 'badge-secondary'
      },
      filterRecruiters() {
        const allUsers = JSON.parse(localStorage.getItem('allusers'))
        this.recruiters = [{
          "id": 1,
          "title": "All",
          "emp_id": "All"
        }]
        const recs = allUsers.filter(item => (item.role.toLowerCase() === "TALENT-ADVISOR-SOURCER".toLowerCase() || item.role.toLowerCase() === "ACCOUNT-MANAGER".toLowerCase() || item.role.toLowerCase() === "TALENT-ADVISOR".toLowerCase()) && (item.emp_id === this.mgrSelected || item.manager === this.mgrSelected));
        this.recruiters = [...this.recruiters, ...recs]
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      clearSelected() {
        this.selected = []
      },
      clearFilter() {
        this.recSelected = ''
        this.mgrSelected = ''
        this.locSelected = ''
        this.clientSelected = ''
        this.sourceSelected = ''
        this.selected = this.POFUOptions.map(option => option.value)
        this.filter = null
        if (this.$route.query.filter) {
          this.$router.replace({ query: { ...this.$route.query, filter: undefined } });
        }
      },
      
      parseMaybeJson(value) {
        if (!value) return null
        if (typeof value === 'object') return value
        if (typeof value !== 'string') return null
        const trimmed = value.trim()
        if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return null
        try {
          const parsed = JSON.parse(trimmed)
          return parsed && typeof parsed === 'object' ? parsed : null
        } catch (e) {
          return null
        }
      },
      collectDateSources(item) {
        if (!item || typeof item !== 'object') return []
        const extra = this.parseMaybeJson(item.extra_details) || {}
        const metadata = this.parseMaybeJson(item.metadata) || {}
        const offerProcess = this.parseMaybeJson(item.offerProcess) || {}
        const offerLetter = extra.offerLetter || extra.offer_letter || extra.offerDetails
          || item.offerDetails || item.offer_details || item.offerLetter || item.offer_letter || {}
        const offerAccepted = offerProcess.offerAccepted || {}
        const offerDesk = offerProcess.offerDesk || {}
        return [item, extra, offerLetter, metadata, offerAccepted, offerDesk].filter(
          source => source && typeof source === 'object' && !Array.isArray(source)
        )
      },
      pickFirstDate(...values) {
        for (let i = 0; i < values.length; i++) {
          const value = values[i]
          if (value !== undefined && value !== null && String(value).trim() !== '') {
            return value
          }
        }
        return ''
      },
      resolveOfferedDate(item) {
        const values = []
        this.collectDateSources(item).forEach(source => {
          values.push(
            source.offered_date,
            source.offeredDate,
            source.offerDate,
            source.dateOfOffer,
            source.OFFERED_DATE,
            source['Offered Date']
          )
        })
        return this.pickFirstDate(...values)
      },
      resolveJoiningDate(item) {
        const values = []
        this.collectDateSources(item).forEach(source => {
          values.push(
            source.joining_date,
            source.joiningDate,
            source.doj,
            source.expectedDoj,
            source.expected_doj,
            source.date_of_joining,
            source.dateOfJoining,
            source.JOINING_DATE,
            source.DOJ,
            source['Joining Date']
          )
        })
        return this.pickFirstDate(...values)
      },
      normalizePofuRow(item) {
        const mapped = {
          ...item,
          offered_date: this.resolveOfferedDate(item),
          joining_date: this.resolveJoiningDate(item),
        }
        if (item.CLIENT === 'KPMG RPO' && item.offerProcess) {
          mapped.latestOfferStage = this.getLatestOfferStage(item.offerProcess)
        }
        return mapped
      },
      unwrapStatusRow(res) {
        if (!res || res.status !== 'OK') return null
        if (Array.isArray(res.data)) return res.data[0] || null
        if (res.data && typeof res.data === 'object') return res.data
        return null
      },
      datesFromCandidateView(res, jid) {
        if (!res || res.status !== 'OK' || !res.data) return { offered: '', joining: '' }
        const jobs = Array.isArray(res.data.candidateJobs) ? res.data.candidateJobs : []
        const job = jobs.find(j => (
          String(j.id) === String(jid)
          || String(j.job_id) === String(jid)
          || String(j.jid) === String(jid)
        )) || jobs[0] || {}
        const candidate = (res.data.candidateData && res.data.candidateData[0]) || {}
        const merged = {
          ...candidate,
          ...job,
          extra_details: job.extra_details || candidate.extra_details,
          metadata: candidate.metadata || job.metadata,
          offerProcess: job.offerProcess || candidate.offerProcess,
        }
        return {
          offered: this.resolveOfferedDate(merged),
          joining: this.resolveJoiningDate(merged),
        }
      },
      applyResolvedDates(row, offered, joining) {
        if (offered && !row.offered_date) this.$set(row, 'offered_date', offered)
        if (joining && !row.joining_date) this.$set(row, 'joining_date', joining)
      },
      async enrichOfferedJoiningDates(rows) {
        const gen = this.dateEnrichGen + 1
        this.dateEnrichGen = gen
        const list = Array.isArray(rows) ? rows : []
        const missing = list.filter(row => !this.resolveOfferedDate(row) || !this.resolveJoiningDate(row))
        const pageStart = (this.currentPage - 1) * this.perPage
        const pageCids = new Set(list.slice(pageStart, pageStart + this.perPage).map(row => row && row.cid))
        missing.sort((a, b) => {
          const aOnPage = pageCids.has(a.cid) ? 0 : 1
          const bOnPage = pageCids.has(b.cid) ? 0 : 1
          return aOnPage - bOnPage
        })
        if (!missing.length) {
          this.isReadyToDownload = true
          return
        }

        const probe = missing[0]
        let useStatusApi = false
        try {
          const statusRes = await candidateService.getCandidateCurrentStatus(probe.cid, probe.jid)
          if (gen !== this.dateEnrichGen) return
          const statusRow = this.unwrapStatusRow(statusRes)
          const statusDates = {
            offered: this.resolveOfferedDate(statusRow),
            joining: this.resolveJoiningDate(statusRow),
          }
          if (statusDates.offered || statusDates.joining) {
            useStatusApi = true
            this.applyResolvedDates(probe, statusDates.offered, statusDates.joining)
          }
        } catch (e) {
          useStatusApi = false
        }
        if (gen !== this.dateEnrichGen) return

        if (useStatusApi) {
          await this.enrichViaStatusApi(missing.slice(1), gen)
        } else {
          await this.enrichViaCandidateView(missing, gen)
        }
        if (gen === this.dateEnrichGen) this.isReadyToDownload = true
      },
      async enrichViaStatusApi(rows, gen) {
        const CONCURRENCY = 4
        let cursor = 0
        const worker = async () => {
          while (cursor < rows.length) {
            if (gen !== this.dateEnrichGen) return
            const row = rows[cursor]
            cursor += 1
            if (this.resolveOfferedDate(row) && this.resolveJoiningDate(row)) continue
            try {
              const res = await candidateService.getCandidateCurrentStatus(row.cid, row.jid)
              if (gen !== this.dateEnrichGen) return
              const statusRow = this.unwrapStatusRow(res)
              this.applyResolvedDates(
                row,
                this.resolveOfferedDate(statusRow),
                this.resolveJoiningDate(statusRow)
              )
            } catch (e) { /* keep blank when a row has no date */ }
          }
        }
        await Promise.all(Array.from({ length: Math.min(CONCURRENCY, rows.length) }, () => worker()))
      },
      async enrichViaCandidateView(rows, gen) {
        const ids = []
        const seen = new Set()
        rows.forEach(row => {
          if (!row || row.cid == null || row.cid === '') return
          const key = String(row.cid)
          if (seen.has(key)) return
          seen.add(key)
          ids.push(row.cid)
        })
        if (!ids.length) return

        await candidateService.getCandidatesByIds(ids, {
          concurrency: 4,
          shouldAbort: () => gen !== this.dateEnrichGen,
          onEach: (id, res) => {
            if (gen !== this.dateEnrichGen) return
            this.compiledData.forEach(row => {
              if (String(row.cid) !== String(id)) return
              const dates = this.datesFromCandidateView(res, row.jid)
              this.applyResolvedDates(row, dates.offered, dates.joining)
            })
          },
        })
      },
      formatDisplayDate(value) {
        if (!value) return '—'
        const raw = String(value).trim()
        if (!raw) return '—'
        const dateOnly = raw.match(/^(\d{4}-\d{2}-\d{2})/)
        const parsed = dateOnly ? moment(dateOnly[1], 'YYYY-MM-DD', true) : moment(raw)
        if (!parsed.isValid()) return '—'
        return parsed.format('DD MMM YYYY')
      },
      getLatestOfferStage(offerProcessData) {
        if (!offerProcessData) return null;
        
        try {
          const offerProcess = typeof offerProcessData === 'string' ? JSON.parse(offerProcessData) : offerProcessData;
          
          // Define the order of stages
          const stageOrder = [
            'tagging', 'fitment', 'offerDesk', 'kgsBGV', 'offerAccepted', 'clientBGV'
          ];
          
          let latestStage = null;
          let latestStatus = null;
          
          // Find the latest completed stage
          for (let i = stageOrder.length - 1; i >= 0; i--) {
            const stage = stageOrder[i];
            if (offerProcess[stage] && offerProcess[stage].status) {
              const status = offerProcess[stage].status;
              if (status === 'Tagged' || status === 'Raised' || status === 'Extended' || 
                  status === 'Initiated' || status === 'InProcess With Client' || 
                  status === 'Pending With Candidate' || status === 'Cleared' || 
                  status === 'Yes' || status === 'No' || status === 'Re-release') {
                latestStage = stage;
                latestStatus = status;
                break;
              }
            }
          }
          
          if (latestStage) {
            // Format the stage name for display
            const stageNames = {
              'tagging': 'Tagging',
              'fitment': 'Fitment',
              'offerDesk': 'Offer Desk',
              'kgsBGV': 'KGS BGV',
              'offerAccepted': 'Offer Accepted',
              'clientBGV': 'Client BGV'
            };
            
            return `${stageNames[latestStage]}: ${latestStatus}`;
          }
          
          return null;
        } catch (error) {
          console.error('Error parsing offer process data:', error);
          return null;
        }
      },
    },
    mounted() {
      adminConfigService.getATSDropdownList().then(res => {
        if(res.status === 200) {
          const sourceList = res.data && res.data.data && res.data.data.sourceList
          if (Array.isArray(sourceList)) {
            this.sources = sourceList
          }
          // this.qualifications = res.data.data.qualificationList
        }
      })
      
      // Apply filter from route query if available
      if (this.$route.query.filter) {
        this.filter = this.$route.query.filter
        console.log('Filter applied on mount:', this.filter)
      }
      
      // this.getReport();
    }
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  @import '@core/scss/vue/apps/ops-tracker.scss';
  </style>
  